// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kqVX","content":"styles_content__1It9X","row":"styles_row__13T73","footer":"styles_footer__5NHau","phraseLength":"styles_phraseLength__wb9wY"};